import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { BookOpenIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { isAuthenticated } from '../services/authService';
import Layout from './Layout';

/**
 * 매뉴얼 화면 껍데기.
 *
 * 매뉴얼은 로그인하지 않아도 볼 수 있어야 한다.
 * - 로그인 상태  : 평소처럼 앱 레이아웃(사이드바/헤더) 안에서 보여준다.
 * - 비로그인 상태: 앱 레이아웃은 서버 데이터를 필요로 하므로 쓸 수 없다.
 *                 대신 로그인 버튼만 있는 가벼운 헤더를 붙여서 보여준다.
 */
const PublicManualShell = () => (
  <div className="min-h-screen bg-slate-50">
    <header className="sticky top-0 z-10 border-b border-slate-200 bg-white">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4">
        <Link to="/manuals" className="flex items-center gap-2 text-slate-900 hover:text-primary-600">
          <BookOpenIcon className="h-5 w-5" />
          <span className="text-sm font-semibold">여행사 업무 시스템 매뉴얼</span>
        </Link>
        <Link
          to="/login"
          className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50"
        >
          <ArrowRightOnRectangleIcon className="h-4 w-4" />
          로그인
        </Link>
      </div>
    </header>

    <main className="mx-auto max-w-6xl">
      <Outlet />
    </main>
  </div>
);

const ManualRouteShell = () => (isAuthenticated() ? <Layout /> : <PublicManualShell />);

export default ManualRouteShell;
